import Axios, { AxiosInstance } from "axios";
import { WelcomeContent } from '@/models/content/welcome'
import { InitialRequirementsContent } from '@/models/content/initial-requirements';
import { StartApplicationPickProgramsWayneContent } from '@/models/content/start-application-pick-programs-wayne';
import { SorryNotAreaContent } from '@/models/content/sorry-not-area';
import { PreviouslyAppliedHSContent } from '@/models/content/previously-applied-hs';
import { StartApplicationContent } from '@/models/content/start-application';
import { MatchNoneCDCContent } from '@/models/content/match-none-cdc';
import { MatchNoneAndGSRPContent } from '@/models/content/match-none-and-gsrp';
import { MatchNoneAndGSRPReferralContent } from '@/models/content/match-none-and-gsrp-referral';
import { MatchNoneContent } from '@/models/content/match-none';
import { MatchHSAndGSRPContent } from '@/models/content/match-hs-and-gsrp';
import { MatchHSAndGSRPReferralContent } from '@/models/content/match-hs-and-gsrp-referral';
import { MatchHeadstartContent } from '@/models/content/match-headstart';
import { MatchHeadstartReferralContent } from '@/models/content/match-headstart-referral';
import { MatchHeadstartAndHSGSRPLikelyReferralContent } from '@/models/content/match-headstart-and-hs-gsrp-likely-referral';
import { MatchNoneCDCLikelyAndGSRPContent } from '@/models/content/match-none-cdc-likely-and-gsrp';
import { MatchGSRPContent } from '@/models/content/match-gsrp';
import { MatchGSRPReferralContent } from '@/models/content/match-gsrp-referral';
import { MatchGSRPLikelyReferralContent } from '@/models/content/match-gsrp-likely-referral';
import { IncomeRangeContent } from '@/models/content/income-range';
import { HeadstartPickProgramsWayneContent } from '@/models/content/headstart-pick-programs-wayne';
import { GSRPPickProgramsWayneContent } from '@/models/content/gsrp-pick-programs-wayne';
import { AlternateHSQualifierUnder4Content } from '@/models/content/alternate-hs-qualifier-under-4';
import { AlternateHSQualifierContent } from '@/models/content/alternate-hs-qualifier';
import { AlternateGSRPQualifierList2Content } from '@/models/content/alternate-gsrp-qualifier-list-2'
import { AlternateGSRPQualifierContent } from '@/models/content/alternate-gsrp-qualifier'
import { CareGiver1Content } from '@/models/content/caregiver-1'
import { CareGiver2WayneContent } from '@/models/content/caregiver-2-wayne'
import { CareGiver3Content } from '@/models/content/caregiver-3'
import { Child1Content } from '@/models/content/child-1'
import { Child2Content } from '@/models/content/child-2'
import { FinalDetailsContent } from '@/models/content/final-details'
import { FinalDetails2Content } from '@/models/content/final-details-2'
import { HouseholdInformationContent } from '@/models/content/household-information'
import { ThankYouContent } from '@/models/content/thank-you'
import { SorryPageNotFoundContent } from '@/models/content/sorry-page-not-found'
import { DownloadContent } from '@/models/content/download';
import { LocationsContent } from '@/models/content/locations';
import { FeedbackContent } from '@/models/content/feedback';
import { FeedbackResponseContent } from '@/models/content/feedback-response';
import { Route } from 'vue-router'
import { Followup211Content } from '@/models/content/followup-211';
import { Ready4kContent } from '@/models/content/ready4k';
import { FeedbackRaffleContent } from '@/models/content/feedback-raffle';
import { ParentPageContent } from '@/models/content/parent-page';
import { CommonContent } from "@/models/content/common";
import { FeedbackFollowupContent } from "@/models/content/feedback-followup";
import { AlternateHSQualifierList2Content } from "@/models/content/alternate-hs-qualifier-list-2";
import { AlternateHSQualifierList3Content } from "@/models/content/alternate-hs-qualifier-list-3";
import { AlternateHSQualifierUnder4List2Content } from "@/models/content/alternate-hs-qualifier-under-4-list-2";
import { AlternateHSQualifierUnder4List3Content } from "@/models/content/alternate-hs-qualifier-under-4-list-3";
import { MatchNoneAndGSRPLikelyReferralContent } from "@/models/content/match-none-and-gsrp-likely-referral";
import { MatchHSGSRPLikelyReferralContent } from "@/models/content/match-hs-gsrp-likely-referral";
import { MatchNoneCDCLikelyAndGSRPReferralContent } from "@/models/content/match-none-cdc-likely-and-gsrp-referral";
import { FinalDetailsEligibilityContent } from "@/models/content/final-details-eligibility";
export class ContentService {
    private _api: AxiosInstance;
    private textDirection: string;
    private language: string;

    constructor( route: Route | null = null){
        let contentDir = route?.params?.lang;

        if ( contentDir == null || contentDir === 'en') {
            contentDir = 'en-us'
            this.language = 'en'
        } else {
            this.language = contentDir;
        } 

        this._api = Axios.create({
            baseURL: `/content/${contentDir}/`,
            responseType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if ( contentDir === 'ar'){
            this.textDirection = 'rtl';
        } else {
            this.textDirection = 'ltr';
        }

    }

    public TextDirection() {
        return this.textDirection;
    }

    public Language() {
        return this.language;
    }

    async getWelcomeContent(): Promise<WelcomeContent> {
        return this.getPageContent<WelcomeContent>('welcome.json')
    }

    async getInitialRequirementsContent(): Promise<InitialRequirementsContent> {
        return this.getPageContent<InitialRequirementsContent>('initial-requirements.json')
    }

    async getStartApplicationPickProgramsContent(): Promise<StartApplicationPickProgramsWayneContent> {
        return this.getPageContent<StartApplicationPickProgramsWayneContent>('start-application-pick-programs-wayne.json')
    }

    async getSorryNotAreaContent(): Promise<SorryNotAreaContent> {
        return this.getPageContent<SorryNotAreaContent>('sorry-not-area.json')
    }

    async getPreviouslyAppliedHSContent(): Promise<PreviouslyAppliedHSContent> {
        return this.getPageContent<PreviouslyAppliedHSContent>('previously-applied-hs.json')
    }

    async getStartApplicationContent(): Promise<StartApplicationContent> {
        return this.getPageContent<StartApplicationContent>('start-application.json')
    }

    async getMatchNoneCDCContent(): Promise<MatchNoneCDCContent> {
        return this.getPageContent<MatchNoneCDCContent>('match-none-cdc.json')
    }

    async getMatchNoneAndGSRPContent(): Promise<MatchNoneAndGSRPContent> {
        return this.getPageContent<MatchNoneAndGSRPContent>('match-none-and-gsrp.json')
    }

    async getMatchNoneAndGSRPReferralContent(): Promise<MatchNoneAndGSRPReferralContent> {
        return this.getPageContent<MatchNoneAndGSRPReferralContent>('match-none-and-gsrp-referral.json')
    }

    async getMatchNoneAndGSRPLikelyReferralContent(): Promise<MatchNoneAndGSRPLikelyReferralContent> {
        return this.getPageContent<MatchNoneAndGSRPLikelyReferralContent>('match-none-and-gsrp-likely-referral.json')
    }

    async getMatchNoneContent(): Promise<MatchNoneContent> {
        return this.getPageContent<MatchNoneContent>('match-none.json')
    }

    async getMatchHSAndGSRPContent(): Promise<MatchHSAndGSRPContent> {
        return this.getPageContent<MatchHSAndGSRPContent>('match-hs-and-gsrp.json')
    }

    async getMatchHSAndGSRPReferralContent(): Promise<MatchHSAndGSRPReferralContent> {
        return this.getPageContent<MatchHSAndGSRPReferralContent>('match-hs-and-gsrp-referral.json')
    }

    async getMatchHeadStartContent(): Promise<MatchHeadstartContent> {
        return this.getPageContent<MatchHeadstartContent>('match-headstart.json')
    }

    async getMatchHeadStartReferralContent(): Promise<MatchHeadstartReferralContent> {
        return this.getPageContent<MatchHeadstartReferralContent>('match-headstart-referral.json')
    }

    async getMatchHSGSRPLikelyReferralContent(): Promise<MatchHSGSRPLikelyReferralContent> {
        return this.getPageContent<MatchHSGSRPLikelyReferralContent>('match-hs-gsrp-likely-referral.json')
    }

    async getMatchHeadStartAndHSGSRPLikelyReferralContent(): Promise<MatchHeadstartAndHSGSRPLikelyReferralContent> {
        return this.getPageContent<MatchHeadstartAndHSGSRPLikelyReferralContent>('match-headstart-and-hs-gsrp-likely-referral.json')
    }    

    async getMatchNoneCDCLikelyAndGSRPContent(): Promise<MatchNoneCDCLikelyAndGSRPContent> {
        return this.getPageContent<MatchNoneCDCLikelyAndGSRPContent>('match-none-cdc-likely-and-gsrp.json')
    }

    async getMatchNoneCDCLikelyAndGSRPReferralContent(): Promise<MatchNoneCDCLikelyAndGSRPReferralContent> {
        return this.getPageContent<MatchNoneCDCLikelyAndGSRPReferralContent>('match-none-cdc-likely-and-gsrp-referral.json')
    }

    async getMatchGSRPContent(): Promise<MatchGSRPContent> {
        return this.getPageContent<MatchGSRPContent>('match-gsrp.json')
    }

    async getMatchGSRPReferralContent(): Promise<MatchGSRPReferralContent> {
        return this.getPageContent<MatchGSRPReferralContent>('match-gsrp-referral.json')
    }

    async getMatchGSRPLikelyReferralContent(): Promise<MatchGSRPLikelyReferralContent> {
        return this.getPageContent<MatchGSRPLikelyReferralContent>('match-gsrp-likely-referral.json')
    }

    async getIncomeRangeContent(): Promise<IncomeRangeContent> {
        return this.getPageContent<IncomeRangeContent>('income-range.json')
    }

    async getHeadstartPickProgramsContent(): Promise<HeadstartPickProgramsWayneContent> {
        return this.getPageContent<HeadstartPickProgramsWayneContent>('headstart-pick-programs-wayne.json')
    }

    async getGSRPPickProgramsContent(): Promise<GSRPPickProgramsWayneContent> {
        return this.getPageContent<GSRPPickProgramsWayneContent>('gsrp-pick-programs-wayne.json')
    }

    async getAlternateHSQualifierUnder4Content(): Promise<AlternateHSQualifierUnder4Content> {
        return this.getPageContent<AlternateHSQualifierUnder4Content>('alternate-hs-qualifier-under-4.json')
    }

    async getAlternateHSQualifierUnder4List2Content(): Promise<AlternateHSQualifierUnder4List2Content> {
        return this.getPageContent<AlternateHSQualifierUnder4List2Content>('alternate-hs-qualifier-under-4-list-2.json')
    }

    async getAlternateHSQualifierUnder4List3Content(): Promise<AlternateHSQualifierUnder4List3Content> {
        return this.getPageContent<AlternateHSQualifierUnder4List3Content>('alternate-hs-qualifier-under-4-list-3.json')
    }

    async getAlternateHSQualifierContent(): Promise<AlternateHSQualifierContent> {
        return this.getPageContent<AlternateHSQualifierContent>('alternate-hs-qualifier.json')
    }

    async getAlternateHSQualifierList2Content(): Promise<AlternateHSQualifierList2Content> {
        return this.getPageContent<AlternateHSQualifierList2Content>('alternate-hs-qualifier-list-2.json')
    }

    async getAlternateHSQualifierList3Content(): Promise<AlternateHSQualifierList3Content> {
        return this.getPageContent<AlternateHSQualifierList3Content>('alternate-hs-qualifier-list-3.json')
    }

    async getAlternateGSRPQualifierList2(): Promise<AlternateGSRPQualifierList2Content> {
        return this.getPageContent<AlternateGSRPQualifierList2Content>('alternate-gsrp-qualifier-list-2.json')
    }

    async getAlternateGSRPQualifier(): Promise<AlternateGSRPQualifierContent> {
        return this.getPageContent<AlternateGSRPQualifierContent>('alternate-gsrp-qualifier.json')
    }

    async getCareGiver1Content(): Promise<CareGiver1Content> {
        return this.getPageContent<CareGiver1Content>('caregiver-1.json')
    }

    async getCareGiver2Content(): Promise<CareGiver2WayneContent> {
        return this.getPageContent<CareGiver2WayneContent>('caregiver-2-wayne.json')
    }

    async getCareGiver3Content(): Promise<CareGiver3Content> {
        return this.getPageContent<CareGiver3Content>('caregiver-3.json')
    }

    async getChild1Content(): Promise<Child1Content> {
        return this.getPageContent<Child1Content>('child-1.json')
    }

    async getChild2Content(): Promise<Child2Content> {
        return this.getPageContent<Child2Content>('child-2.json')
    }

    async getFinalDetailsContent(): Promise<FinalDetailsContent> {
        return this.getPageContent<FinalDetailsContent>('final-details.json')
    }

    async getFinalDetails2Content(): Promise<FinalDetails2Content> {
        return this.getPageContent<FinalDetails2Content>('final-details-2.json')
    }

    async getFinalDetailsEligibilityContent(): Promise<FinalDetailsEligibilityContent> {
        return this.getPageContent<FinalDetailsEligibilityContent>('final-details-eligibility.json')
    }

    async getHouseholdInformationContent(): Promise<HouseholdInformationContent> {
        return this.getPageContent<HouseholdInformationContent>('household-information.json')
    }

    async getThankYouContent(): Promise<ThankYouContent> {
        return this.getPageContent<ThankYouContent>('thank-you-sites.json')
    }

    async getSorryPageNotFoundContent(): Promise<SorryPageNotFoundContent> {
        return this.getPageContent<SorryPageNotFoundContent>('sorry-page-not-found.json')
    }

    async getDownloadContent(): Promise<DownloadContent> {
        return this.getPageContent<DownloadContent>('download.json')
    }

    async getLocationsContent(): Promise<LocationsContent> {
        return this.getPageContent<LocationsContent>('locations.json')
    }

    async getFeedbackContent(): Promise<FeedbackContent> {
        return this.getPageContent<FeedbackContent>('feedback.json')
    }

    async getFeedbackResponseContent(): Promise<FeedbackResponseContent> {
        return this.getPageContent<FeedbackResponseContent>('feedback-response.json')
    }

    async getFollowup211Content(): Promise<Followup211Content> {
        return this.getPageContent<Followup211Content>('followup-211.json')
    }

    async getFeedbackFollowupContent(): Promise<FeedbackFollowupContent> {
        return this.getPageContent<DownloadContent>('feedback-followup.json')
    }

    async getReady4kContent(): Promise<Ready4kContent> {
        return this.getPageContent<Ready4kContent>('ready4k.json')
    }

    async getFeedbackRaffleContent(): Promise<FeedbackRaffleContent> {
        return this.getPageContent<FeedbackRaffleContent>('feedback-raffle.json')
    }

    async getParentPageContent(): Promise<ParentPageContent> {
        return this.getPageContent<ParentPageContent>('parent-page.json')
    }    

    async getCommonContent(): Promise<CommonContent> {
        return this.getPageContent<CommonContent>('common.json')
    }

    private async getPageContent<C>(jsonFile: string): Promise<C> {
        const result = await this._api.get<C>(jsonFile);
        return result.data;
    }
}
